import { ProductFormData } from '@/@types/Products'
import { EmailVerification } from '@/components/shared/SupportEmailVerification'
import { Button } from '@/components/ui/button'
import {
  UseFormClearErrors,
  UseFormSetError,
  UseFormWatch,
} from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface Step4VerifySupportEmailProps {
  watch: UseFormWatch<ProductFormData>
  setError: UseFormSetError<ProductFormData>
  clearErrors: UseFormClearErrors<ProductFormData>
  verifiedSupportEmail: string | null
  onSupportEmailVerified: (email: string) => void
  handleBack: () => void
  handleNext: () => void
}

export default function Step4VerifySupportEmail({
  watch,
  setError,
  clearErrors,
  verifiedSupportEmail,
  onSupportEmailVerified,
  handleBack,
  handleNext,
}: Step4VerifySupportEmailProps) {
  const { t } = useTranslation(['common', 'onboarding'])

  const emailSupport = (watch('email_support') || '').trim()
  const productName = watch('name')

  const goToNextStep = () => {
    setTimeout(() => {
      handleNext()
    }, 700)
  }

  return (
    <div className="w-full max-w-lg">
      <h1 className="text-2xl font-bold text-center mb-6">
        {t('verifyEmail')}
        <p className="text-interactive">{t('supportEmailVerificationEnterCode')}</p>
      </h1>

      <EmailVerification
        email={emailSupport}
        productName={productName}
        verifiedEmail={verifiedSupportEmail}
        onVerified={(email) => {
          clearErrors('email_support')
          onSupportEmailVerified(email)
        }}
        onInvalidDomain={() => {
          setError('email_support', {
            type: 'manual',
            message: t('supportEmailInvalidDomain'),
          })
        }}
        onVerificationComplete={goToNextStep}
        leadingActions={
          <Button type="button" onClick={handleBack} variant="ghost">
            {t('back')}
          </Button>
        }
      />
    </div>
  )
}
